import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

// Disable console logs in production
if (import.meta.env.VITE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const PUBLIC_LINK_PATHS = new Set(['/external-link', '/share-design']);

const BootShellBoundary = ({ children }) => {
  useEffect(() => {
    document.getElementById('app-boot-shell')?.remove();
  }, []);

  return children;
};

const renderApplication = async () => {
  const isPublicLinkPage = PUBLIC_LINK_PATHS.has(window.location.pathname);
  const module = isPublicLinkPage
    ? await import('./pages/ExternalLinkLandingPage.jsx')
    : await import('./App.jsx');
  const RootComponent = module.default;
  const root = ReactDOM.createRoot(document.getElementById('root'));

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <BootShellBoundary>
          <RootComponent />
        </BootShellBoundary>
      </BrowserRouter>
    </React.StrictMode>
  );
};

renderApplication().catch((error) => {
  console.error('Unable to start Dream Book:', error);
  const message = document.querySelector('.app-boot-shell__message');
  if (message) {
    message.textContent = 'Dream Book could not load. Please refresh and try again.';
  }
});















